module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.row.show) ? _c('div', {
    staticClass: "activityBox"
  }, [_c('div', {
    staticClass: "activity-box"
  }, [_c('img', {
    staticClass: "activity-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/bg-goods-activity.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-goods-detail"
  }, [_c('img', {
    staticClass: "activity-goods-img",
    attrs: {
      "src": _vm.row.pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-goods-title-box"
  }, [_c('div', {
    staticClass: "ac-goods-title"
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "ac-title"
  }, [_c('div', {
    staticClass: "ac-name",
    style: ('background:' + _vm.row.color)
  }, [_vm._v(_vm._s(_vm.row.tag))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.desc))])])])]), _vm._v(" "), _c('div', {
    staticClass: "activity-join"
  }, [_c('div', {
    staticClass: "activity-count-down"
  }, [_c('div', [_vm._v("活动倒计时 ")]), _vm._v(" "), _c('div', {
    staticClass: "count-down"
  }, [_c('van-count-down', {
    attrs: {
      "time": (_vm.row.last_time + 1) * 1000
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(timeData) {
        return [_c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.days))]), _vm._v("天\n              "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.hours))]), _vm._v(" "), _c('span', {
          staticClass: "sign"
        }, [_vm._v(":")]), _vm._v(" "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.minutes))]), _vm._v(" "), _c('span', {
          staticClass: "sign"
        }, [_vm._v(":")]), _vm._v(" "), _c('span', {
          staticClass: "item"
        }, [_vm._v(_vm._s(timeData.seconds))])]
      }
    }], null, false, 3427013958)
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "activity-join-btn"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.goTuanDetail(_vm.row.url)
      }
    }
  }, [_vm._v("立即参加")])])]), _vm._v(" "), _c('div', {
    staticClass: "ac-close",
    on: {
      "click": _vm.closeActivity
    }
  }, [_c('img', {
    staticClass: "ac-close-img",
    attrs: {
      "src": "https://static.dierqudao.com/images/icon-close@2x.png"
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc5eaec6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ActivityDialog.vue
// module id = 2646
// module chunks = 0